import {CancelTokenSource} from 'axios';

export const cleanUp = (cancelToken: CancelTokenSource): () => void  => function cleanUp() {
  cancelToken.cancel('Request canceled due to cleanup');
};
